import * as React from 'react'
import { cn } from '@/lib/utils'

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, ...props }, ref) => {
    return React.createElement('div', {
      ref,
      className: cn('ui-card', className),
      ...props,
    })
  }
)
Card.displayName = 'Card'
